import { c as n, o as E, r as L, i as I, a as M, b as S } from "./sectionRegistry-C_nU9Ouc.js";
const k = { skipSeconds: 15, throttleMs: 100, rootMargin: "50px" },
    d = {
        audio: "[data-audio-element]",
        playButton: "[data-play-button]",
        prevButton: "[data-prev-button]",
        nextButton: "[data-next-button]",
        progressBar: "[data-progress-bar]",
        progressFill: "[data-progress-fill]",
        progressHandle: "[data-progress-handle]",
        currentTime: "[data-current-time]",
        duration: "[data-duration]",
        playIcon: ".audio-player__icon--play",
        pauseIcon: ".audio-player__icon--pause",
    };
class C extends HTMLElement {
    constructor(t = {}) {
        super(),
            (this.audio = null),
            (this.playButton = null),
            (this.prevButton = null),
            (this.nextButton = null),
            (this.progressBar = null),
            (this.progressFill = null),
            (this.progressHandle = null),
            (this.currentTimeEl = null),
            (this.durationEl = null),
            (this.state = {
                isDragging: !1,
                isInitialized: !1,
                animationFrameId: null,
                lastUpdateTime: 0,
                observer: null,
            }),
            (this.config = { ...k, ...t }),
            this.bindMethods();
    }
    bindMethods() {
        (this.handlePlayClick = this.handlePlayClick.bind(this)),
            (this.handlePrevClick = this.handlePrevClick.bind(this)),
            (this.handleNextClick = this.handleNextClick.bind(this)),
            (this.handleProgressClick = this.handleProgressClick.bind(this)),
            (this.handleProgressMouseDown = this.handleProgressMouseDown.bind(this)),
            (this.handleProgressMouseMove = this.handleProgressMouseMove.bind(this)),
            (this.handleProgressMouseUp = this.handleProgressMouseUp.bind(this)),
            (this.handleTimeUpdate = this.handleTimeUpdate.bind(this)),
            (this.handleLoadedMetadata = this.handleLoadedMetadata.bind(this)),
            (this.handlePlay = this.handlePlay.bind(this)),
            (this.handlePause = this.handlePause.bind(this)),
            (this.handleEnded = this.handleEnded.bind(this));
    }
    connectedCallback() {
        this.setupIntersectionObserver();
    }
    disconnectedCallback() {
        this.destroy();
    }
    setupIntersectionObserver() {
        (this.state.observer = new IntersectionObserver(
            (t) => {
                t.forEach((e) => {
                    e.isIntersecting && !this.state.isInitialized && (this.init(), this.state.observer?.disconnect());
                });
            },
            { rootMargin: this.config.rootMargin }
        )),
            this.state.observer.observe(this);
    }
    init() {
        if (!this.state.isInitialized) {
            if ((this.cacheElements(), !this.audio)) {
                n("[AudioPlayer] No audio element found", "warn");
                return;
            }
            this.setupEventListeners(),
                (this.state.isInitialized = !0),
                (this.audio.preload = "metadata"),
                n("[AudioPlayer] Initialized", "info");
        }
    }
    cacheElements() {
        (this.audio = this.querySelector(d.audio)),
            (this.playButton = this.querySelector(d.playButton)),
            (this.prevButton = this.querySelector(d.prevButton)),
            (this.nextButton = this.querySelector(d.nextButton)),
            (this.progressBar = this.querySelector(d.progressBar)),
            (this.progressFill = this.querySelector(d.progressFill)),
            (this.progressHandle = this.querySelector(d.progressHandle)),
            (this.currentTimeEl = this.querySelector(d.currentTime)),
            (this.durationEl = this.querySelector(d.duration));
    }
    setupEventListeners() {
        this.audio &&
            (this.audio.addEventListener("loadedmetadata", this.handleLoadedMetadata, { passive: !0 }),
            this.audio.addEventListener("loadeddata", this.handleLoadedMetadata, { passive: !0 }),
            this.audio.addEventListener("canplaythrough", this.handleLoadedMetadata, { passive: !0 }),
            this.audio.addEventListener("durationchange", this.handleLoadedMetadata, { passive: !0 }),
            this.audio.addEventListener("timeupdate", this.handleTimeUpdate, { passive: !0 }),
            this.audio.addEventListener("play", this.handlePlay, { passive: !0 }),
            this.audio.addEventListener("pause", this.handlePause, { passive: !0 }),
            this.audio.addEventListener("ended", this.handleEnded, { passive: !0 }),
            this.audio.readyState >= 1 && this.handleLoadedMetadata(),
            this.playButton?.addEventListener("click", this.handlePlayClick),
            this.prevButton?.addEventListener("click", this.handlePrevClick),
            this.nextButton?.addEventListener("click", this.handleNextClick),
            this.progressBar &&
                (this.progressBar.addEventListener("click", this.handleProgressClick),
                this.progressBar.addEventListener("mousedown", this.handleProgressMouseDown),
                this.progressBar.addEventListener("touchstart", this.handleProgressMouseDown, { passive: !1 })));
    }
    removeEventListeners() {
        this.audio &&
            (this.audio.removeEventListener("loadedmetadata", this.handleLoadedMetadata),
            this.audio.removeEventListener("loadeddata", this.handleLoadedMetadata),
            this.audio.removeEventListener("canplaythrough", this.handleLoadedMetadata),
            this.audio.removeEventListener("durationchange", this.handleLoadedMetadata),
            this.audio.removeEventListener("timeupdate", this.handleTimeUpdate),
            this.audio.removeEventListener("play", this.handlePlay),
            this.audio.removeEventListener("pause", this.handlePause),
            this.audio.removeEventListener("ended", this.handleEnded)),
            this.playButton?.removeEventListener("click", this.handlePlayClick),
            this.prevButton?.removeEventListener("click", this.handlePrevClick),
            this.nextButton?.removeEventListener("click", this.handleNextClick),
            this.progressBar &&
                (this.progressBar.removeEventListener("click", this.handleProgressClick),
                this.progressBar.removeEventListener("mousedown", this.handleProgressMouseDown),
                this.progressBar.removeEventListener("touchstart", this.handleProgressMouseDown)),
            document.removeEventListener("mousemove", this.handleProgressMouseMove),
            document.removeEventListener("mouseup", this.handleProgressMouseUp),
            document.removeEventListener("touchmove", this.handleProgressMouseMove),
            document.removeEventListener("touchend", this.handleProgressMouseUp);
    }
    formatTime(t) {
        if (isNaN(t)) return "0:00";
        const e = Math.floor(t / 60),
            i = Math.floor(t % 60);
        return `${e}:${i.toString().padStart(2, "0")}`;
    }
    handleLoadedMetadata() {
        if (!(!this.audio || !this.durationEl))
            if (this.audio.duration && isFinite(this.audio.duration)) {
                const t = this.formatTime(this.audio.duration);
                this.durationEl.textContent = t;
            } else
                window.setTimeout(() => {
                    if (this.audio && this.durationEl && this.audio.duration && isFinite(this.audio.duration)) {
                        const t = this.formatTime(this.audio.duration);
                        this.durationEl.textContent = t;
                    }
                }, 100);
    }
    handleTimeUpdate() {
        if (!this.audio || this.state.isDragging) return;
        const t = window.performance.now();
        t - this.state.lastUpdateTime < (this.config.throttleMs || 100) ||
            ((this.state.lastUpdateTime = t),
            this.state.animationFrameId && window.cancelAnimationFrame(this.state.animationFrameId),
            (this.state.animationFrameId = window.requestAnimationFrame(() => {
                this.updateProgress();
            })));
    }
    updateProgress() {
        if (
            !(!this.audio || !this.currentTimeEl || !this.progressFill || !this.progressHandle) &&
            ((this.currentTimeEl.textContent = this.formatTime(this.audio.currentTime)),
            this.durationEl &&
                this.audio.duration &&
                isFinite(this.audio.duration) &&
                this.durationEl.textContent === "0:00" &&
                (this.durationEl.textContent = this.formatTime(this.audio.duration)),
            this.audio.duration)
        ) {
            const t = (this.audio.currentTime / this.audio.duration) * 100;
            (this.progressFill.style.transform = `scaleX(${t / 100})`), (this.progressHandle.style.left = `${t}%`);
        }
    }
    handlePlay() {
        if (!this.playButton) return;
        const t = this.playButton.querySelector(d.playIcon),
            e = this.playButton.querySelector(d.pauseIcon);
        t && e && ((t.style.display = "none"), (e.style.display = "block")),
            this.playButton.setAttribute("aria-label", "Pause"),
            this.classList.add("audio-player--playing");
    }
    handlePause() {
        if (!this.playButton) return;
        const t = this.playButton.querySelector(d.playIcon),
            e = this.playButton.querySelector(d.pauseIcon);
        t && e && ((t.style.display = "block"), (e.style.display = "none")),
            this.playButton.setAttribute("aria-label", "Play"),
            this.classList.remove("audio-player--playing");
    }
    handleEnded() {
        this.handlePause(), this.audio && ((this.audio.currentTime = 0), this.updateProgress());
    }
    handlePlayClick() {
        this.audio &&
            (this.audio.paused
                ? (this.audio.preload === "metadata" && (this.audio.preload = "auto"),
                  this.audio.play().catch((t) => {
                      n("[AudioPlayer] Error playing audio", "error", t);
                  }))
                : this.audio.pause());
    }
    handlePrevClick() {
        this.audio &&
            ((this.audio.currentTime = Math.max(0, this.audio.currentTime - (this.config.skipSeconds || 15))),
            this.updateProgress());
    }
    handleNextClick() {
        this.audio &&
            ((this.audio.currentTime = Math.min(
                this.audio.duration,
                this.audio.currentTime + (this.config.skipSeconds || 15)
            )),
            this.updateProgress());
    }
    handleProgressClick(t) {
        this.state.isDragging || this.seek(t);
    }
    handleProgressMouseDown(t) {
        this.state.isDragging = !0;
        const e = "touches" in t ? t.touches[0] : t;
        this.seek(e),
            document.addEventListener("mousemove", this.handleProgressMouseMove),
            document.addEventListener("mouseup", this.handleProgressMouseUp),
            document.addEventListener("touchmove", this.handleProgressMouseMove, { passive: !1 }),
            document.addEventListener("touchend", this.handleProgressMouseUp),
            t.preventDefault();
    }
    handleProgressMouseMove(t) {
        if (!this.state.isDragging) return;
        const e = "touches" in t ? t.touches[0] : t;
        this.seek(e), "touches" in t && t.preventDefault();
    }
    handleProgressMouseUp() {
        (this.state.isDragging = !1),
            document.removeEventListener("mousemove", this.handleProgressMouseMove),
            document.removeEventListener("mouseup", this.handleProgressMouseUp),
            document.removeEventListener("touchmove", this.handleProgressMouseMove),
            document.removeEventListener("touchend", this.handleProgressMouseUp);
    }
    seek(t) {
        if (!this.progressBar || !this.audio || !this.audio.duration) return;
        const e = this.progressBar.getBoundingClientRect(),
            i = t.clientX,
            r = Math.max(0, Math.min(1, (i - e.left) / e.width)) * this.audio.duration;
        (this.audio.currentTime = r), this.updateProgress();
    }
    destroy() {
        this.state.animationFrameId && window.cancelAnimationFrame(this.state.animationFrameId),
            this.removeEventListeners(),
            this.audio && (this.audio.pause(), (this.audio.currentTime = 0)),
            this.state.observer && (this.state.observer.disconnect(), (this.state.observer = null)),
            (this.state.isInitialized = !1),
            n("[AudioPlayer] Destroyed", "info");
    }
}
typeof window < "u" && !window.customElements.get("audio-player") && window.customElements.define("audio-player", C);
class B extends HTMLElement {
    constructor() {
        super(...arguments),
            (this.variantData = []),
            (this.defaultTabs = null),
            (this.currentVariantId = null),
            (this.productId = null),
            (this.tabs = null),
            (this.pubsubUnsubscriber = null);
    }
    connectedCallback() {
        n("VariantTabs custom element connected", "info"), this.init();
    }
    disconnectedCallback() {
        this.destroy();
    }
    init() {
        this.cacheElementsAndData() &&
            (this.bindEvents(), this.updateTabsContent(), n("VariantTabs initialization complete", "info"));
    }
    cacheElementsAndData() {
        const t = this.querySelector("[data-variant-tabs-data]"),
            e = this.querySelector("[data-variant-tabs-defaults]");
        if (((this.tabs = this.querySelectorAll("[data-variant-tab]")), !t))
            return n("Variant tabs data element not found", "error"), !1;
        try {
            (this.variantData = JSON.parse(t.textContent || "[]")),
                n("Parsed variant tabs data", "info", this.variantData);
        } catch (r) {
            return n("Failed to parse variant tabs data", "error", r), !1;
        }
        if (e)
            try {
                (this.defaultTabs = JSON.parse(e.textContent || "null")),
                    n("Parsed default tabs data", "info", this.defaultTabs);
            } catch (r) {
                n("Failed to parse default tabs data", "error", r);
            }
        const i = this.getAttribute("data-current-variant-id");
        i && ((this.currentVariantId = parseInt(i, 10)), n("Initial variant ID", "info", this.currentVariantId));
        const a = this.getAttribute("data-product-id");
        return a && ((this.productId = parseInt(a, 10)), n("Product ID", "info", this.productId)), !0;
    }
    bindEvents() {
        this.subscribeToPubsub();
    }
    subscribeToPubsub() {
        if (this.pubsubUnsubscriber) {
            n("VariantTabs: already subscribed, skipping", "info");
            return;
        }
        E(() => {
            const t = window;
            if (!t.theme?.pubsub) {
                n("VariantTabs: pubsub not available", "warn");
                return;
            }
            try {
                (this.pubsubUnsubscriber = t.theme.pubsub.subscribe(
                    t.theme.pubsub.PUB_SUB_EVENTS.variantChange,
                    (e) => {
                        const i = e,
                            a = i?.data?.productId,
                            r = i?.data?.variant?.id;
                        if (this.productId && a) {
                            const o = typeof a == "string" ? parseInt(a, 10) : a;
                            if (o !== this.productId) {
                                n("VariantTabs: ignoring variant change from different product", "info", {
                                    thisProductId: this.productId,
                                    eventProductId: o,
                                });
                                return;
                            }
                        }
                        if (r) {
                            const o = typeof r == "string" ? parseInt(r, 10) : r;
                            n(
                                `Variant change detected via pubsub (element: ${this.classList.contains("lg:hidden") ? "mobile" : "desktop"})`,
                                "info",
                                { raw: r, parsed: o }
                            ),
                                (this.currentVariantId = o),
                                this.updateTabsContent();
                        } else n("Variant change event received but no variant ID found", "warn", e);
                    }
                )),
                    n(
                        `VariantTabs subscribed to pubsub (element: ${this.classList.contains("lg:hidden") ? "mobile" : "desktop"})`,
                        "info"
                    );
            } catch (e) {
                n("VariantTabs: error subscribing to pubsub", "error", e);
            }
        });
    }
    updateTabsContent() {
        if (!this.currentVariantId || !this.tabs) return;
        n("VariantTabs update - searching for variant", "info", {
            currentVariantId: this.currentVariantId,
            currentVariantIdType: typeof this.currentVariantId,
            availableVariantIds: this.variantData.map((i) => ({
                id: i.id,
                type: typeof i.id,
                hasTabs: i.tabs !== null,
            })),
        });
        const t = this.variantData.find((i) => i.id === this.currentVariantId),
            e = t?.tabs;
        if (
            (n("VariantTabs lookup result", "info", {
                found: !!t,
                hasTabs: !!e,
                tabData: e ? { tab_1: e.tab_1, tab_2: e.tab_2, tab_3: e.tab_3 } : null,
            }),
            !e)
        ) {
            n("No metafield tab data for variant, hiding dynamic tabs", "info", this.currentVariantId),
                this.tabs.forEach((i) => {
                    i.style.display = "none";
                });
            return;
        }
        this.tabs.forEach((i) => {
            const a = i.getAttribute("data-variant-tab");
            if (!a) return;
            const r = `tab_${a}`,
                o = `tab_${a}_content`,
                l = e[r],
                u = e[o],
                m = i.querySelector("[data-tab-heading]"),
                b = i.querySelector("[data-tab-content]");
            m && l && (m.textContent = l),
                b && u && (b.innerHTML = u),
                l && u ? (i.style.display = "") : (!l || !u) && (i.style.display = "none");
        }),
            n("Updated tabs content for variant", "info", this.currentVariantId);
    }
    destroy() {
        this.pubsubUnsubscriber && (this.pubsubUnsubscriber(), (this.pubsubUnsubscriber = null)),
            n("VariantTabs destroyed", "info");
    }
}
window.customElements.get("variant-tabs") ||
    (window.customElements.define("variant-tabs", B), n("variant-tabs custom element registered", "info"));
class A extends HTMLElement {
    constructor() {
        super(...arguments),
            (this._elements = null),
            (this._hoverTimeout = null),
            (this._selectedIndex = 0),
            (this._abortController = null);
    }
    connectedCallback() {
        (this._abortController = new AbortController()),
            (this._selectedIndex = parseInt(this.getAttribute("selected-index") || "0", 10)),
            this._bindEvents(),
            this._updateActiveStates(),
            n("MegaMenuTabs initialized", "info");
    }
    disconnectedCallback() {
        this._cleanup();
    }
    get _elements$() {
        return (
            this._elements ||
                ((this._elements = { buttons: Array.from(this.querySelectorAll('[role="tab"]')), panels: [] }),
                this._elements.buttons.forEach((t) => {
                    const e = t.getAttribute("aria-controls");
                    if (e) {
                        const i = document.getElementById(e);
                        i && this._elements && this._elements.panels.push(i);
                    }
                })),
            this._elements
        );
    }
    _bindEvents() {
        const t = this._abortController?.signal;
        this._elements$.buttons.forEach((e, i) => {
            e.addEventListener("mouseenter", () => this._handleHover(i), { signal: t }),
                e.addEventListener("mouseleave", () => this._cancelHover(), { signal: t }),
                e.addEventListener("click", (a) => this._handleClick(a, e, i), { signal: t }),
                e.addEventListener("focus", () => this._handleHover(i), { signal: t });
        }),
            window.Shopify?.designMode &&
                this.addEventListener(
                    "shopify:block:select",
                    (e) => {
                        const i = e.target,
                            a = this._elements$.buttons.indexOf(i);
                        a !== -1 && this._switchToTab(a);
                    },
                    { signal: t }
                );
    }
    _handleHover(t) {
        this._cancelHover(), t !== this._selectedIndex && this._switchToTab(t);
    }
    _cancelHover() {
        this._hoverTimeout && (window.clearTimeout(this._hoverTimeout), (this._hoverTimeout = null));
    }
    _handleClick(t, e, i) {
        const a = e.getAttribute("data-href") || e.getAttribute("href");
        if (a) {
            window.location.href = a;
            return;
        }
        t.preventDefault(), this._switchToTab(i);
    }
    _switchToTab(t) {
        if (t === this._selectedIndex || t < 0 || t >= this._elements$.panels.length) return;
        const e = this._elements$.panels[this._selectedIndex],
            i = this._elements$.panels[t];
        if (!e || !i) return;
        (e.hidden = !0), (i.hidden = !1);
        const a = i.querySelector("motion-list");
        a?.load && a.load(),
            (this._selectedIndex = t),
            this.setAttribute("selected-index", t.toString()),
            this._updateActiveStates();
    }
    _updateActiveStates() {
        this._elements$.buttons.forEach((t, e) => {
            const i = e === this._selectedIndex;
            t.setAttribute("aria-selected", i.toString()),
                t.classList.toggle("is-active", i),
                t.tagName === "BUTTON" && (t.disabled = i);
        });
    }
    _cleanup() {
        this._cancelHover(), this._abortController?.abort(), (this._abortController = null), (this._elements = null);
    }
    load() {
        const t = this._elements$.panels[this._selectedIndex];
        if (!t) return;
        const e = t.querySelector("motion-list");
        e?.load && e.load();
    }
    unload() {
        const t = this._elements$.panels[this._selectedIndex];
        if (!t) return;
        const e = t.querySelector("motion-list");
        e?.unload && e.unload();
    }
}
window.customElements.get("mega-menu-tabs") ||
    (window.customElements.define("mega-menu-tabs", A), n("mega-menu-tabs custom element registered", "info"));
const f = "VariantPickerAutoSelect",
    O = 1e4,
    h = new Map(),
    c = new Map();
function y(s) {
    const t = s.querySelectorAll('input[type="radio"]:checked');
    return Array.from(t)
        .map((e) => e.getAttribute("data-option-value-id"))
        .filter((e) => e !== null);
}
function _(s, t) {
    if (s.length !== t.length) return !0;
    const e = [...s].sort(),
        i = [...t].sort();
    return e.some((a, r) => a !== i[r]);
}
function T(s) {
    const t = s.querySelector('input[type="radio"]:checked');
    if (t) {
        n(`[${f}] Triggering refetch via auto-selection`, "info");
        const e = new Event("change", { bubbles: !0 });
        t.dispatchEvent(e);
    }
}
function p(s) {
    const t = c.get(s);
    t && (t.disconnect(), c.delete(s));
}
function V(s, t) {
    p(s);
    const e = document.getElementById(s);
    if (!e?.parentElement) return;
    const i = e.parentElement,
        a = new MutationObserver(() => {
            const r = document.getElementById(s);
            if (!r) return;
            const o = y(r);
            o.length !== 0 &&
                _(t, o) &&
                (n(`[${f}] Picker updated with different options (null variant case), triggering refetch`, "info"),
                p(s),
                h.delete(s),
                T(r));
        });
    a.observe(i, { childList: !0 }),
        c.set(s, a),
        window.setTimeout(() => {
            c.get(s) === a && p(s);
        }, O);
}
function v() {
    const s = window;
    s.theme?.pubsub &&
        (s.theme.pubsub.subscribe(s.theme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, (t) => {
            const e = t,
                i = e?.data?.selectedOptionValues || [],
                a = e?.data?.target;
            if (!a || i.length === 0) return;
            const r = a.closest("variant-picker, variant-selects");
            r?.id && (h.set(r.id, i), V(r.id, i));
        }),
        s.theme.pubsub.subscribe(s.theme.pubsub.PUB_SUB_EVENTS.variantChange, (t) => {
            const e = t,
                i = e?.data?.variant,
                a = e?.data?.sectionId,
                r = e?.data?.productId;
            if (i?.available) {
                h.clear(), c.forEach((b) => b.disconnect()), c.clear();
                return;
            }
            const o = `VariantPicker-${a}-${r}`,
                l = document.getElementById(o);
            if (!l) return;
            const u = h.get(o);
            if (!u) return;
            const m = y(l);
            _(u, m)
                ? (n(`[${f}] Auto-selection detected via variantChange, triggering refetch`, "info"),
                  p(o),
                  h.delete(o),
                  T(l))
                : (h.delete(o), p(o));
        }));
}
function x() {
    const s = window;
    if (s.theme?.pubsub) {
        v();
        return;
    }
    let t = 0;
    const e = 50,
        i = window.setInterval(() => {
            t++, s.theme?.pubsub ? (window.clearInterval(i), v()) : t >= e && window.clearInterval(i);
        }, 100);
}
x();
const U = {
        pageLoaded: "page:loaded",
        cartUpdated: "cart:updated",
        ajaxProductAdded: "ajaxProduct:added",
        ajaxProductError: "ajaxProduct:error",
        quickviewOpen: "quickview:open",
        quickviewLoaded: "quickview:loaded",
        variantChange: "variant:change",
        collectionReloaded: "collection:reloaded",
    },
    g = () => {
        const s = document.querySelector("loading-bar");
        s &&
            ((s.style.transition = "opacity 200ms ease-out"),
            (s.style.opacity = "0"),
            window.setTimeout(() => {
                s.hidden = !0;
            }, 200));
    };
document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", g, { once: !0 }) : g();
window.STOREFRONT = window.STOREFRONT || {};
window.STOREFRONT.settings = { devMode: !0 };
window.STOREFRONT.theme = { shopName: "nanit uk", moneyFormat: "£{{amount}}", currency: "GBP", currencySymbol: "£" };
window.STOREFRONT.events = window.STOREFRONT.events || new EventTarget();
const w = [];
let P = !1;
const D = (s, t) => {
        const e = (i) => t(i);
        return document.addEventListener(s, e), () => document.removeEventListener(s, e);
    },
    F = (s) => {
        if (P) {
            s();
            return;
        }
        w.push(s);
    };
window.STOREFRONT.EVENTS = U;
window.STOREFRONT.on = D;
window.STOREFRONT.onPubsubReady = E;
window.STOREFRONT.ready = F;
n("Storefront initialized", "info");
const N = () => {
    try {
        n("[InitializeApp] Starting application initialization", "info"),
            I(),
            n("[InitializeApp] Pubsub bridge initialized", "info"),
            M(),
            n("[InitializeApp] Global events initialized", "info"),
            S(),
            n("[InitializeApp] Section lifecycles registered", "info"),
            (P = !0),
            w.forEach((s) => {
                try {
                    s();
                } catch (t) {
                    n("Error in STOREFRONT.ready callback", "error", t);
                }
            }),
            n("[InitializeApp] Application initialization complete", "info");
    } catch (s) {
        n("Error during application initialization", "error", s);
    }
};
window.addEventListener("DOMContentLoaded", N, { once: !0 });
window.addEventListener("load", L);


//Change the dollar sign to pound sign
(function () {
  function convertDollarPrices() {
    const prices = document.querySelectorAll(
      'bundle-recommendations .price, bundle-recommendations .price-compare'
    );

    prices.forEach(function (price) {
      const text = price.textContent.trim();

      if (text.startsWith('$')) {
        price.textContent = '£' + text.substring(1);
      }
    });
  }

  convertDollarPrices();

  const bundle = document.querySelector('bundle-recommendations');

  if (bundle) {
    const observer = new MutationObserver(convertDollarPrices);

    observer.observe(bundle, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }
})();